import React from "react";
import ContactCard from "./contact_card";

export interface ContactData {
  id: string;
  col1_1: string;
  col1_2: string;
  col2_1: string;
  col2_2: string;
  col2_3: number;
}

interface ContactCardProps {
  contacts: ContactData[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

const ContactCardList: React.FC<ContactCardProps> = ({
  contacts,
  onEdit,
  onDelete,
}) => (
  <div className="contactList">
    {contacts.map((contact, index) => (
      <ContactCard
        onEdit={onEdit}
        onDelete={onDelete}
        key={`ContactCard-${index}`}
        contact={contact}
      />
    ))}
  </div>
);

export default ContactCardList;
